
import type { PropType } from 'vue'
import type { EpbAlertType } from './epb-alert.types'
import { defineComponent } from 'vue'
import { EpbButton } from '../epb-button'
import { EpbText } from '../epb-text'

export default defineComponent({
  name: 'EpbAlert',
  components: {
    EpbButton,
    EpbText,
  },
  props: {
    type: {
      type: String as PropType<EpbAlertType>,
      default: 'info',
    },
    removable: Boolean,
  },
  emits: {
    close: () => {},
  },
  setup() {
    return {
      baseClass: 'epb-alert',
    }
  },
})
